'use strict';

angular.module('scrapQcrmApp')
  .controller('AddTelecallerCtrl', function($scope, $uibModalInstance, telecallerData, telecallerService, growl, $rootScope, $global) {

    $scope.data = {};
    $scope.submitted = false;
    $scope.title = 'ADD';

    // Pre-fill city from logged-in admin
    $scope.data.city = $rootScope.loginData ? $rootScope.loginData.city : '';

    // If editing, populate form
    if (telecallerData) {
      $scope.title = 'EDIT';
      $scope.data.telecallerId    = telecallerData.telecallerId;
      $scope.data.name            = telecallerData.name;
      $scope.data.mobileNo        = telecallerData.mobileNo;
      $scope.data.email           = telecallerData.email;
      $scope.data.city            = telecallerData.city;
      $scope.data.existingPassword = telecallerData.plainPassword || null; // show current plain password
    }

    $scope.generatePassword = function() {
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var pwd = '';
      for (var i = 0; i < 8; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      $scope.data.password = pwd;
    };

    $scope.submit = function() {
      $scope.submitted = true;

      if ($scope.telecallerForm.$invalid) {
        return;
      }

      var payload = {
        name:     $scope.data.name,
        mobileNo: $scope.data.mobileNo,
        email:    $scope.data.email,
        city:     $scope.data.city,
        password: $scope.data.password || ''
      };

      var call;
      if ($scope.title === 'ADD') {
        call = telecallerService.addTelecaller(payload);
      } else {
        payload.telecallerId = $scope.data.telecallerId;
        // On edit, call editTelecaller first, then if a new password was entered
        // also call resetPassword so auth credentials are updated correctly
        call = telecallerService.editTelecaller(payload).then(function(res) {
          if ((res.statusCode === 200 || res.status === 'Success' || res.status === 'SUCCESS') &&
              $scope.data.password && $scope.data.password.trim()) {
            return telecallerService.resetPassword($scope.data.telecallerId, $scope.data.password);
          }
          return res;
        });
      }

      call.then(function(res) {
        if (res.statusCode === 200 || res.status === 'Success' || res.status === 'SUCCESS') {
          growl.success($scope.title === 'ADD' ? 'Telecaller added successfully' : 'Telecaller updated successfully');

          // If the edited telecaller is the currently logged-in user, refresh their session data
          if ($scope.title === 'EDIT' && $rootScope.loginData &&
              $rootScope.loginData.userid === $scope.data.telecallerId) {
            $rootScope.loginData.username = $scope.data.name;
            $rootScope.loginData.mobileNo = $scope.data.mobileNo;
            $rootScope.loginData.userName = $scope.data.mobileNo; // login credential key
            $global.setLocalItem('loginData', $rootScope.loginData, true);
          }

          $uibModalInstance.close('success');
        } else {
          var errMsg = 'Failed to save telecaller';
          if (res.error) {
            errMsg = res.error.code || errMsg;
          } else if (res.message) {
            errMsg = res.message;
          }
          growl.error(errMsg);
        }
      }).catch(function(err) {
        console.error('Telecaller save error:', err);
        var errMsg = 'Failed to save telecaller. Please try again.';
        if (err && err.data && err.data.error) {
          errMsg = err.data.error.code || errMsg;
        } else if (err && err.data && err.data.message) {
          errMsg = err.data.message;
        }
        growl.error(errMsg);
      });
    };

    $scope.cancel = function() {
      $uibModalInstance.dismiss('cancel');
    };
  });
